import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnChanges, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-switch-tabs',
  templateUrl: './switch-tabs.component.html',
  styleUrls: ['./switch-tabs.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchTabsComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SwitchTabsComponent implements OnChanges, AfterViewInit {
  @Input() value: any;
  @Input() formControlName: string;
  @Input() name = '';
  @Input() disabled = false;
  @Input() disableInput = false;
  @Input() inputWidth = '325px';
  @Input() options: [any, string][];
  @ViewChild('marker', { static: false }) private marker: ElementRef<HTMLInputElement>;
  @ViewChildren('switchInput') private switchInputs: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChildren('switchLabel') private switchLabels: QueryList<ElementRef<HTMLInputElement>>;

  onChange: (_: boolean) => void;
  onTouch: () => void;

  readonly inputId: string;

  constructor() {
    this.onChange = () => {};
    this.onTouch = () => {};
    this.inputId = String(Math.floor(Math.random() * 1000000));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options?.previousValue !== changes.options?.currentValue) {
      this.setMarkerWidth();
    }
  }

  ngAfterViewInit() {
    this.setMarkerWidth();
  }

  writeValue(value: any) {
    this.value = value;
    this.setMarkerPosition(this.value);
  }

  registerOnChange(fn: (_: any) => {}) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}) {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.disableInput = isDisabled;
  }

  private setMarkerWidth() {
    if (this.marker) {
      const markerWidth = 100 / (this.options?.length || 1) - 2 / (this.options?.length || 1);
      this.marker.nativeElement.style.width = markerWidth + '%';
    }
  }

  private setMarkerPosition(value: any) {
    if (this.marker) {
      const position = Math.max(
        this.options.findIndex(option => option[0] === value),
        0
      );
      const leftPosition = (100 / (this.options.length || 1)) * position + 1 / (this.options.length || 1);
      this.marker.nativeElement.style.left = leftPosition + '%';
    }
  }
}
